import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  helperText?: string;
}

export function Input({ label, helperText, className, id, ...props }: InputProps) {
  const inputId = id ?? props.name ?? label;

  return (
    <label className="flex flex-col gap-2 text-sm text-mist" htmlFor={inputId}>
      <span className="font-medium uppercase tracking-[0.14em] text-parchment/90">
        {label}
      </span>
      <input
        id={inputId}
        className={cn(
          "rounded-2xl border border-gold/20 bg-black/20 px-4 py-3 text-parchment outline-none transition placeholder:text-mist/45 focus:border-gold/55 focus:bg-black/30",
          className,
        )}
        {...props}
      />
      {helperText && <span className="text-xs text-mist/80">{helperText}</span>}
    </label>
  );
}
